module.exports = __webpack_public_path__ + "static/img/075_TO8_1706.8d5210d.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/075_TO8_1706.jpg
// module id = YIko
// module chunks = 0